<template>
  <footer>
    <div class="container-fluid p-md-lg">
        <div class="row" style="display: none">
            <div class="col-12 build-info mt-3">
                <span>Revision - 957fa35 del 5/22/2020 10:39:53 AM</span>
            </div>
        </div>
        <div class="row logo-container sm-center">
            <div class="col-12 col-sm-5 my-auto">
                <a href="http://www.camcom.gov.it" rel="noopener" target="_blank" style="color:white">
                    <img class="logo-camcom img-fluid" src="@/assets/svg/cdci.svg" alt="CAMERE DI COMMERCIO D'ITALIA">
                </a>
            </div>
            <div class=".d-none .d-sm-block col-2"></div>
            <div class="col-12 col-sm-5 my-auto footer-ic">
            <p class="text-right" style="display: inline-block;">{{ $t("msg.servizio-realizzato-da") }}   </p>
            <a href="https://www.infocamere.it" rel="noopener" target="_blank" style="color:white">
                    <img class="logo-ic" src="@/assets/images/infocamere.png" alt="Servizio realizzato da Infocamere">
                </a>
            </div>
        </div>
        <hr>
        <div class="row info-container">
        <div class="col-md-auto footer-links text-center text-md-left mb-2 mb-md-0">
            <a href="https://informative.infocamere.it/depositi-e-istanze-registro-imprese" class="mano" rel="noopener" target="_blank">{{ $t("msg.note-legali-policy")}}</a>

            <span class="mx-2">|</span>

            <a href="https://informative.infocamere.it/informativa-pratiche-CCIAA" class="mano" rel="noopener" target="_blank">{{ $t("msg.pratiche-policy")}}</a>

            <span class="mx-2">|</span>

            <a href="https://dire.registroimprese.it/depositi-e-istanze-registro-imprese.html" class="mano" rel="noopener" target="_blank">{{ $t("msg.pratiche-accessibilita")}}</a>

            </div>
        </div>
        <div class="row info-container">
            <div class="dati-ic  text-center text-md-left">
                    {{$t("msg.footer-address")}}
                </div>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
  }
}
</script>

<style lang="scss">
  @import "@/assets/sass/dire.scss";
</style>
